module.exports = __webpack_public_path__ + "static/02-9b2e8ce9bb8199e0c8d7a2aa5348313c.jpg";